import { Dialog, DialogContent, DialogContentText, DialogActions, Button, DialogTitle } from "@mui/material";
import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ConfirmationDialog: React.FunctionComponent<{
    title: string;
    message: string;
    show: boolean;
    onClose?: (result: boolean) => void;
    buttonConfirmationText?: string;
    buttonCancellationText?: string;
}> = (props) => {
    const [show, setShow] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        setShow(props.show);
    }, [props.show]);

    return <Dialog
        open={show}
        keepMounted
        onClose={() => setShow(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
    >
        <DialogTitle>
            {props.title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">{props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => {
                setShow(false);
                if (props.onClose) {
                    props.onClose(false);
                }
            }} color="primary">{props.buttonCancellationText || t("general.cancel")}</Button>
            <Button onClick={() => {

                if (props.onClose) {
                    props.onClose(true);
                }
                setShow(false);
            }} color="primary"><b>{`${props.buttonConfirmationText || t("general.ok")}`}</b></Button>
        </DialogActions>
    </Dialog>
}

ConfirmationDialog.propTypes = {
    title: propTypes.string.isRequired,
    message: propTypes.string.isRequired,
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired,
}

export default ConfirmationDialog;